import { Typography, Box } from "@material-ui/core";

import moment from "moment";

import { Icon } from "../base";
import { ShaDowBox } from "../boxes";
import { PieChart, PieLegends } from "../charts";
import { METER_PER_UNIT } from "../../services/constants";
import readyImg from "../../assets/images/icons/connect-status-ready.svg";
import standByImg from "../../assets/images/icons/connect-status-standby.svg";
import pendingImg from "../../assets/images/icons/connect-status-pending.svg";
import missingImg from "../../assets/images/icons/connect-status-missing.svg";
import refusedImg from "../../assets/images/icons/connect-status-refused.svg";
import connectedImg from "../../assets/images/icons/connect-status-connected.svg";

export const title = {
  CONNECTED: "Connected",
  READY: "Ready to connect",
  STAND_BY: "Stand by",
  PENDING: "Pending (more info required)",
  MISSING: "Missing",
  6: "Don't want to connect",
};

export const iconSrc = {
  CONNECTED: connectedImg,
  READY: readyImg,
  STAND_BY: standByImg,
  PENDING: pendingImg,
  MISSING: missingImg,
  FULLY_CONNECTED: connectedImg,
  PARTIALLY_CONNECTED: readyImg,
  UNCONNECTED: refusedImg,
  6: refusedImg,
};

export const ConnectionStatus = ({
  chartData,
  legendColors,
  status,
  meterType,
  sinceConnected,
}) => {
  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">Meters PRaaS-Connection Status</Typography>
        {meterType === METER_PER_UNIT && chartData ? (
          <Box style={{ marginTop: 18 }}>
            <PieChart height={180} data={chartData} colors={legendColors} name="ConnectionStatus" />
            <PieLegends
              data={chartData}
              colors={legendColors}
              unit="nFormatter"
              xs={5}
              marginBottom={2}
            />
          </Box>
        ) : (
          <Box style={{ textAlign: "center", marginTop: 54 }}>
            <Icon style={{ width: 100, height: 100 }} src={iconSrc[status] || iconSrc["PENDING"]} />
            <Typography variant="h3" style={{ marginTop: 34 }}>
              {title[status] || title["PENDING"]}
            </Typography>
            {status === "CONNECTED" && (
              <Typography>since {moment(sinceConnected).format("MMM D, YYYY")}</Typography>
            )}
          </Box>
        )}
      </Box>
    </ShaDowBox>
  );
};
